import type { Persona } from "./persona"

export const COLLECTION_SIDE_MODULE_STATE_COOKIE_NAME =
  "collectionSideModuleState"
export const HOME_SIDE_MODULE_STATE_COOKIE_NAME = "homeSideModuleState"
export const PROFILE_SIDE_MODULE_STATE_COOKIE_NAME = "profileSideModuleState"
export const STATS_SIDE_MODULE_STATE_COOKIE_NAME = "statsSideModuleState"
export const ACTIVITY_SIDE_MODULE_STATE_COOKIE_NAME = "activitySideModuleState"
export const PORTFOLIO_SIDE_MODULE_STATE_COOKIE_NAME =
  "portfolioSideModuleState"
export const TOKENS_SIDE_MODULE_STATE_COOKIE_NAME = "tokensSideModuleState"
export const WATCHLIST_SIDE_MODULE_STATE_COOKIE_NAME =
  "watchlistSideModuleState"
export const TOKEN_WATCHLIST_SIDE_MODULE_STATE_COOKIE_NAME =
  "tokenWatchlistSideModuleState"

export const SIDE_MODULE_STATE = {
  open: "open",
  closed: "closed",
} as const

export type SideModuleState = keyof typeof SIDE_MODULE_STATE

/**
 * The default side module state is based on the persona
 */
export const getDefaultSideModuleState = (persona: Persona) => {
  return persona === "collector" ? "closed" : "open"
}

export function parseSideModuleState(
  sideModuleState: string | undefined,
  persona: Persona,
  defaultSideModuleState?: SideModuleState,
): SideModuleState {
  if (sideModuleState && sideModuleState in SIDE_MODULE_STATE) {
    return sideModuleState as SideModuleState
  }

  if (defaultSideModuleState) {
    return defaultSideModuleState
  }

  return getDefaultSideModuleState(persona)
}

const sideModuleStates = Object.values(SIDE_MODULE_STATE)

export function getSideModuleStatesStaticParams() {
  return sideModuleStates.map(sideModuleState => ({
    sideModuleState,
  }))
}
